<template>
  <sub-page title="我的认证">
    <div class="cert-page">
      <!-- 绿色渐变用户横幅（设计稿成品图，含头像/姓名/证件号/已实人印章） -->
      <div class="user-banner">
        <img :src="bannerImg" class="banner-img" alt="用户信息" />
      </div>

      <!-- 实名认证分组 -->
      <div class="section-label">实名认证</div>
      <div class="group-card">
        <div class="cert-item">
          <img :src="realnameImg" class="cert-icon" alt="实名认证" />
          <span class="cert-name">实名认证</span>
          <span class="cert-badge">已实名</span>
        </div>
      </div>

      <!-- 实人认证分组 -->
      <div class="section-label">实人认证</div>
      <div class="group-card">
        <div class="cert-item" @click="startFace">
          <img :src="faceImg" class="cert-icon" alt="人脸认证" />
          <span class="cert-name">人脸认证</span>
          <span class="cert-badge">已实人</span>
        </div>
        <div class="cert-item">
          <img :src="cardImg" class="cert-icon cert-icon-circle" alt="电子社保卡认证" />
          <span class="cert-name">电子社保卡认证</span>
          <span class="cert-badge">已实人</span>
        </div>
      </div>
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'

export default {
  name: 'MyCertification',
  components: { SubPage },
  data() {
    return {
      bannerImg: require('@/assets/icons/cert-banner.png'),
      realnameImg: require('@/assets/icons/cert-realname.png'),
      faceImg: require('@/assets/icons/cert-face.png'),
      cardImg: require('@/assets/icons/cert-card.png')
    }
  },
  methods: {
    // 人脸认证：演示环境再次刷脸
    startFace() {
      this.$alert('您已通过人脸实人认证，无需重复操作')
    }
  }
}
</script>

<style scoped>
.cert-page {
  background: #F5F5F5;
  min-height: 100%;
  padding-bottom: calc(40 * var(--w));
}
/* 绿色渐变横幅卡（设计稿成品图） */
.user-banner {
  margin: calc(24 * var(--w));
  border-radius: calc(16 * var(--w));
  overflow: hidden;
}
.banner-img {
  display: block;
  width: 100%;
  height: auto;
}
/* 分组标签 */
.section-label {
  padding: calc(28 * var(--w)) calc(40 * var(--w)) calc(20 * var(--w));
  font-size: calc(40 * var(--w));
  color: #323233;
}
.group-card {
  background: #fff;
  overflow: hidden;
}
.cert-item {
  display: flex;
  align-items: center;
  height: calc(150 * var(--w));
  padding: 0 calc(40 * var(--w));
  border-bottom: 1px solid #F0F0F0;
  cursor: pointer;
}
.cert-item:last-child {
  border-bottom: none;
}
.cert-icon {
  width: calc(72 * var(--w));
  height: calc(72 * var(--w));
  flex-shrink: 0;
  object-fit: contain;
}
/* 电子社保卡认证：官方红色图标圆形裁切，与人脸认证图标呈现形式一致 */
.cert-icon-circle {
  border-radius: 50%;
  object-fit: cover;
}
.cert-name {
  flex: 1;
  margin-left: calc(28 * var(--w));
  font-size: calc(42 * var(--w));
  color: #323233;
}
/* 右侧橙框徽标：已实名/已实人 */
.cert-badge {
  flex-shrink: 0;
  padding: calc(10 * var(--w)) calc(28 * var(--w));
  border: calc(2 * var(--w)) solid #D88230;
  border-radius: calc(12 * var(--w));
  font-size: calc(36 * var(--w));
  color: #D88230;
  line-height: 1.2;
}
</style>



// WEBPACK FOOTER //
// src/pages/MyCertification.vue